import {Component} from '@angular/core';

@Component({
  selector: 'playback-ico',
  templateUrl: './playback-ico.component.html'
})
export class PlaybackIcoComponent {
}
